import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '../material.module';
import { MaterialExtensionsModule } from '@ng-matero/extensions';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressHttpModule } from 'ngx-progressbar/http';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';

import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { ErrorCodeComponent } from './components/error-code/error-code.component';

import { DisableControlDirective } from './directives/disable-control.directive';

import { MainPipe } from "../pipe/main-pipe.module";

import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ToObservablePipe } from './pipes/to-observable.pipe';
import { UploadComponent } from "./components/upload/upload.component";
import { NgxPrintModule } from 'ngx-print';

import { CKEditorModule } from 'ng2-ckeditor';
import { FormlyMatDatepickerModule } from "@ngx-formly/material/datepicker";
import { RepeatTypeComponent } from 'app/formly/repeat-section.type';
import { FormlyWrapperPanelComponent } from 'app/formly-wrapper';
import { FormlyWrapperDivComponent } from 'app/formly/formly-wrappers';
import { FormlyFieldTabs } from 'app/formly/tabset.type';
import { MatTabsModule } from '@angular/material/tabs';
import { FormlyFieldFile } from 'app/formly/file-type.component';
const MODULES = [
  MaterialModule,
  MaterialExtensionsModule,
  FlexLayoutModule,
  NgProgressModule,
  NgProgressRouterModule,
  NgProgressHttpModule,
  NgSelectModule,
  FormlyModule,
  FormlyMaterialModule,
  ToastrModule,
  TranslateModule,
  NgxPrintModule,
  CKEditorModule,
  MatTabsModule,

];
const COMPONENTS = [BreadcrumbComponent,
  UploadComponent,
  PageHeaderComponent,
  ErrorCodeComponent,

  RepeatTypeComponent,
  FormlyWrapperPanelComponent,
  FormlyWrapperDivComponent,
  FormlyFieldTabs,
  FormlyFieldFile
];
const COMPONENTS_DYNAMIC = [];
const DIRECTIVES = [DisableControlDirective];
const PIPES = [SafeUrlPipe, ToObservablePipe];

@NgModule({
  declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC, ...DIRECTIVES, ...PIPES],
  imports: [FormlyMatDatepickerModule, CommonModule, FormsModule, RouterModule, ReactiveFormsModule, ...MODULES,
    FormlyModule.forRoot({
      types: [
        { name: 'repeat', component: RepeatTypeComponent },
        {
          name: "tabs",
          component: FormlyFieldTabs
        },
        {
          name: "file",
          component: FormlyFieldFile,
          //wrappers: ['form-field']
        }
      ],
      wrappers: [
        {
          name: 'card',
          component: FormlyWrapperPanelComponent
        },
        {
          name: 'div-row',
          component: FormlyWrapperDivComponent
        }
      ],
    }),
  ],
  exports: [
    FormlyMatDatepickerModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    ...MODULES,
    ...COMPONENTS,
    ...DIRECTIVES,
    ...PIPES, MainPipe
  ],
  entryComponents: COMPONENTS_DYNAMIC,
})
export class SharedModule { }
